import {StateField} from '../angular/models/timecard-entry.model';
import {EntryFieldState} from '../constants/update-source.constant';

/**
 * Resolve the display value from a Field following the initial/adjusted hierarchy:
 * adjusted.value takes precedence when state is Adjusted, otherwise initial.value.
 */
export function resolveFieldValue<T>(field: StateField<T> | undefined | null): T | null {
  if (!field) return null;
  if (field.state === EntryFieldState.Adjusted && field.adjusted?.value !== undefined) {
    return field.adjusted.value;
  }
  return field.initial?.value ?? null;
}
